import React, { useState, useEffect } from "react";
import { Typography, Container, Box, Card, Link } from "@mui/material";
import api from "../globals/axios";
import logo from "../assets/logo/FarmAppLogo.png";
import { useNavigate } from "react-router-dom";
import CustomTraceabilityDashboardCard from "../components/Custom/CustomTraceabilityDashboardCard.js";
import LoaderContainer from "../components/LoaderContainer.js";

export default function TraceabilityDemoHome() {
  const [loading, setLoading] = useState(true);
  const [crops, setCrops] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadProduct = async () => {
      api.get("/buyer/sample-crops/").then((res) => {
        const _crops = res.data.map((f) => {
          const name = `${f.farmland?.farm_name}`;
          const cropName = `${f.commodity?.name}`;
          const date = f.sowing_date;
          const farmImage = f.sowing_file;
          return { id: f.id, farmName: name, cropName, date, farmImage };
        });
        setCrops(_crops);
      });
      setLoading(false);
    };

    loadProduct();
  }, []);

  return (
    <LoaderContainer loading={loading}>
      <Box>
        <Box
          sx={{
            backgroundColor: "white",
            textAlign: "center",
            padding: "10px 0 50px 0",
            borderEndStartRadius: "20px",
            borderEndEndRadius: "20px",
          }}
        >
          <img
            src={logo}
            alt="FarmApp Logo"
            style={{ width: "114px", height: "auto" }}
          />
        </Box>
        <Box
          sx={{
            position: "relative",
            backgroundColor: "#4CAF50",
            textAlign: "center",
            padding: "15px 0",
            margin: "0 35px",
            top: "-30px",
            borderRadius: "20px",
          }}
        >
          <Typography
            sx={{ fontSize: "20px", fontWeight: "400", color: "#ffffff" }}
          >
            Traceability Dashboard
          </Typography>
        </Box>
        <Container maxWidth="xs" style={{ textAlign: "center" }}>
          <Typography variant="subtitle2" sx={{ color: "#000000" }}>
            Here Are Links To Some Sample Crops On The System
          </Typography>

          <Box sx={{ marginTop: "25px" }}>
            {crops.map((crop) => (
              <CustomTraceabilityDashboardCard
                key={crop.id}
                image={crop.farmImage}
                farmName={crop.farmName}
                cropName={crop.cropName}
                date={crop.date}
                onClick={() => {
                  navigate(`/view-crop/${crop.id}`);
                }}
              />
            ))}
          </Box>
          <Card
            sx={{
              textAlign: "center",
              marginTop: "40px",
              backgroundColor: "#ffffff",
              padding: "10px",
              boxShadow: "1px 6px 8px 0px #CCCCCC40",
            }}
          >
            <Link
              href="https://www.asqi.in/"
              target="_blank"
              rel="noopener"
              sx={{ color: "#00A6DA" }}
            >
              https://www.asqi.in/
            </Link>
          </Card>
        </Container>
      </Box>
    </LoaderContainer>
  );
}
